import script from "./Latest.vue?vue&type=script&setup=true&lang=js"
export * from "./Latest.vue?vue&type=script&setup=true&lang=js"

import "./Latest.vue?vue&type=style&index=0&id=be71d5c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be71d5c4"]])

export default __exports__